import { render, staticRenderFns } from "./RentersSimpleList.vue?vue&type=template&id=5cebe257&scoped=true"
import script from "./RentersSimpleList.vue?vue&type=script&lang=js"
export * from "./RentersSimpleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cebe257",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cebe257')) {
      api.createRecord('5cebe257', component.options)
    } else {
      api.reload('5cebe257', component.options)
    }
    module.hot.accept("./RentersSimpleList.vue?vue&type=template&id=5cebe257&scoped=true", function () {
      api.rerender('5cebe257', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/partials/RentersSimpleList.vue"
export default component.exports